/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 18th 2023, 4:16:56 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { URLS } from "core/routes";
import { Organization } from "lib/schemas";
import { SubscriptionPlan } from "saas-subscription/schemas";
import { WelcomeIcon } from "theme/icons";
import { EmphasisText, FullScreenNotificationGrid, OSActionButton } from "ui-widgets";

interface PurchaseSuccessModalProps {
  organization: Organization;
  subscriptionPlan: SubscriptionPlan;
  title?: React.ReactNode;
  content?: React.ReactNode;
}

export const PurchaseSuccessModal = ({ organization, subscriptionPlan, title, content }: PurchaseSuccessModalProps) => {
  const pageTitle = title || (
    <>
      Subscription successfully created for <EmphasisText>{organization?.name}</EmphasisText>. Welcome onboard.
    </>
  );

  const pageContent = content || (
    <>
      <p>
        You have successfully signed up for <EmphasisText>{subscriptionPlan?.name}</EmphasisText>.
      </p>
      <p>
        Get started by installing any of our service templates or building a service from scratch for your organization,{" "}
        <EmphasisText>{organization?.name}</EmphasisText>.
      </p>
    </>
  );

  return (
    <FullScreenNotificationGrid
      pageTitle={pageTitle}
      pageContent={
        <>
          {pageContent}
          <p style={{ paddingBottom: 10 }}>
            <OSActionButton variant="contained" onClick={() => window.location.assign(URLS.dashboard)} size="large">
              Get Started
            </OSActionButton>
          </p>
        </>
      }
      pageIllustration={<WelcomeIcon height={180} width={180} />}
    />
  );
};
